import { z } from "zod";

// Skema untuk anak-anak (detail per agen)
const RoomReportChildV4Schema = z.object({
    agent_name: z.string(),
    room_nights: z.number().int(),
    reservations: z.number().int(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number().int(),
});

// Skema untuk data utama per properti
const RoomReportDataV4Schema = z.object({
    property: z.string(),
    percentage: z.string(), // Tipe adalah string di data utama
    room_nights: z.number().int(),
    reservations: z.number().int(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number().int(),
    children: z.array(RoomReportChildV4Schema),
});

// Skema untuk objek total
const RoomReportTotalV4Schema = z.object({
    percentage: z.number(), // Tipe adalah number di objek total
    room_nights: z.number().int(),
    reservations: z.number().int(),
    avg_nights: z.string(),
    booking_window: z.string(),
    revenue: z.string(),
    ota_com: z.string(),
    avg_rate: z.string(),
    cancel_count: z.number().int(),
});

// Skema respons API utama
export const RoomReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(RoomReportDataV4Schema),
    total: RoomReportTotalV4Schema,
});

export type RoomReportDataV4 = z.infer<typeof RoomReportDataV4Schema>;
export type RoomReportResponseV4 = z.infer<typeof RoomReportResponseV4Schema>;